import script from "./TextSurlignes.vue?vue&type=script&setup=true&lang=js"
export * from "./TextSurlignes.vue?vue&type=script&setup=true&lang=js"

import "./TextSurlignes.vue?vue&type=style&index=0&id=a3d35d4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3d35d4c"]])

export default __exports__